import { defineFeature } from "../../app/feature";
import { ReleaseBatchPage } from "./ReleaseBatchPage";
import { ReleaseCenterPage } from "./ReleaseCenterPage";

/** Release center (task 4130.9; DESIGN-SPEC 28.2): each batch's manifest, preflight, receipts, and
 * reconciliation. It reads and changes nothing. Owned by the export-engine lane. */
export default defineFeature({
  id: "release-center",
  title: "Release center",
  routes: [
    { path: "/release-center", Component: ReleaseCenterPage },
    { path: "/release-center/:batchId", Component: ReleaseBatchPage },
  ],
  nav: { label: "Release center", path: "/release-center", section: "Outputs and Releases", order: 10 },
  permissions: ["engagement.read"],
});
